$(document).ready(function() {
  $(document).foundation();
  var state_data = [];

  //filter products on shop page
  var $filter_dropdown = $( "#product-filter-dropdown" );
  var $products = $('[data-product-tags]');
  var $products_wrap = $('#products-wrap');
  var $products_innerwrap = $('#products-innerwrap');
  var $grid_items = $('.collection-header, .collection-end, .grid__item--shop');
  var $filters = $('[type="checkbox"].filter-child');
  var $filter_parents_wrap = $('.filter-parent-wrap');
  var $filter_parents = $('.filter-parent');
  var $default_filters = $('.filter-child.default');
  var $not_default_filters = $('.filter-child:not(.default)');
  var shop_title = '';
  var page_title = $('head > title').data('title');
  var $title_default = $('#shop-page-title .default');
  var $title_custom = $('#shop-page-title span:not(.default)');
  var $title_type = $('#shop-page-title .type');
  var $title_mushroom = $('#shop-page-title .mushroom');
  var $title_benefit = $('#shop-page-title .benefit');
  var $open_filters = $('#open-filters');
  var $filter_button = $('button[name="product-filter"]:not(.remove-tag)');
  var $clear_filters = $('.clear-filters');
  var $close_filters = $('.close-filters');



  if($filters.length){
    state_data.name = 'product-filter';
  }


  //checkbox filter
  $filters.change(function(){
    filterUpdateUrl();
    filterProducts();
  });


  //single filter (best sellers)
  $filter_dropdown.on( "click", 'button[name="product-filter"]:not(.remove-tag)', function(event) {
    $filters.prop( "checked", false );
    filterUpdateUrl( $(this) );
    filterProducts( $(this) );
    closeFilters(100);
  });


  //remove tag checkbox
  $filter_dropdown.on( "click", ".remove-tag:not(.product-filter):not(.remove-tag-blog)", function() {
    $('.filter-child[value="' + $(this).val() + '"]').prop( "checked", false );
    filterUpdateUrl();
    filterProducts();
  });


  //remove tag button (best sellers)
  $filter_dropdown.on( "click", ".remove-tag.product-filter:not(.remove-tag-blog)", function() {
    $(this).removeClass('remove-tag');
    filterUpdateUrl();
    filterProducts();
  });


  //update url
  function filterUpdateUrl( $single_filter ){
    $single_filter = $single_filter || false;
    state_data.tags = [];
    var tag_url = '';
    var url_index = 0;
    if($single_filter){
      tag_url = $single_filter.val();
      state_data.tags.push($single_filter.val());
    } else {
      $filters.each(function(){
        if($(this).is(':checked')){
          if(url_index != 0){
            tag_url += '+';
          }
          tag_url += $(this).val();
          state_data.tags.push($(this).val());
          url_index ++;
        }
      });
    }
    if(tag_url != ''){
      tag_url = '/' + tag_url;
    }
    history.pushState(state_data, null, '/pages/shop' + tag_url);
  }


  function filterProducts( $single_filter ){
    $single_filter = $single_filter || false;
    var transition_time = 100;
    var $show = $();
    var title_type = '';
    var title_mushroom = '';
    var title_benefit = '';

    var selector = disableFilters( $single_filter );

    if($single_filter){

      $filter_parents.removeClass('active-filter');
      title_type = $single_filter.text();
      title_mushroom = '';
      title_benefit = '';
      $('.remove-tag:not(.product-filter):not(.remove-tag-blog)').addClass('hide');
      $single_filter.addClass('remove-tag');

    } else {

      $('.remove-tag.product-filter:not(.remove-tag-blog)').removeClass('remove-tag');

      $filter_parents.each(function(){
        if($(this).siblings('.filter-dropdown').find('.filter-child:checked').length){
          $(this).addClass('active-filter');
          var this_group = $(this).data('group');

          $(this).siblings('.filter-dropdown').find('.filter-child:checked + .filter__label').each(function(index){
            var text = $(this).text();
            if(index == 0){
              if(this_group == 'product-type'){
                title_type = text;
              } else if(this_group == 'mushroom'){
                title_mushroom = text;
              } else if(this_group == 'benefit'){
                title_benefit = text;
              }
              if(this_group == 'mushroom' && title_type != ''){
                title_mushroom = ' with ' + title_mushroom;
              } else if(this_group == 'benefit' && (title_type != '' || title_mushroom != '')){
                title_benefit = ' for ' + title_benefit;
              }
            } else {
              if(this_group == 'product-type'){
                title_type += ' & ' + text;
              } else if(this_group == 'mushroom'){
                title_mushroom += ' & ' + text;
              } else if(this_group == 'benefit'){
                title_benefit += ' & ' + text;
              }
            }
          });
        } else {
          $(this).removeClass('active-filter');
        }
      });
    }

    if(selector == ''){
      $show = $grid_items;
      $title_custom.fadeOut(transition_time, function(){
        $title_type.text('');
        $title_mushroom.text('');
        $title_benefit.text('');
        $title_default.fadeIn(transition_time);
      });
      shop_title = '';
    } else {
      $show = $(selector).parent();
      console.log($show)
      if($title_default.is(':visible')){
        $title_default.fadeOut(transition_time, function(){
          $title_type.text(title_type);
          $title_mushroom.text(title_mushroom);
          $title_benefit.text(title_benefit);
          $title_custom.fadeIn(transition_time);
        });
      } else {
        $title_custom.fadeOut(transition_time, function(){
          $title_type.text(title_type);
          $title_mushroom.text(title_mushroom);
          $title_benefit.text(title_benefit);
          $title_custom.fadeIn(transition_time);
        });
      }
      shop_title = title_type + title_mushroom + title_benefit;
    }
console.log(page_title)
    if(shop_title != '') {
      document.title = page_title + ' – ' + shop_title;
    } else {
      document.title = page_title;
    }

    //show/hide products
    $products_wrap.css('height', $products_wrap.height());
    $products_wrap.animate({
      opacity: 0
    }, transition_time, function() {

      //after products fadeout, display the new products
  
      $grid_items.hide();
      //add tag-remove button

      if($single_filter){

      } else {

        $filters.each(function(){
          if($(this).is(':checked')){
            $('.remove-tag[value="' + $(this).val() + '"]:not(.product-filter):not(.remove-tag-blog)').removeClass('hide');

          } else {
            $('.remove-tag[value="' + $(this).val() + '"]:not(.product-filter):not(.remove-tag-blog)').addClass('hide');
          }
        });

      }

      if($show.is('.large-up--one-quarter:not(.unfiltered-large-up--one-third)') && $show.hasClass('large-up--one-third') && selector != '' ){
        $show.filter('.large-up--one-third').removeClass('large-up--one-third').addClass('unfiltered-large-up--one-third large-up--one-quarter');
      } else if(selector == '' || (!$show.is('.large-up--one-quarter:not(.unfiltered-large-up--one-third)') && $show.hasClass('unfiltered-large-up--one-third'))){
        $show.filter('.unfiltered-large-up--one-third').removeClass('unfiltered-large-up--one-third large-up--one-quarter').addClass('large-up--one-third');
      }
      $show.show();
      var new_height = $products_innerwrap.outerHeight();
      $products_wrap.animate({
        height: new_height,
        opacity: 1
      }, transition_time, function() {
        $products_wrap.css('height', 'auto');
      });

    });
  }

  function disableFilters( $single_filter, on_load ) {
    //disable/enable filter checkboxes
    if(!$filters.length){return;}
    on_load = on_load || false;
    var selector = '';
    var possible_tags = [];
    $tooltips = $filters.filter('.tooltip');
    if($tooltips.length){
      $tooltips.next('.filter__label').foundation('_destroy').removeAttr( "title" );
    }
    $filters.prop('disabled', false);
    if($single_filter){
      selector = '[data-product-tags*="\\"' + $single_filter.val() + '\\""]';
      $products_innerwrap.addClass('filtered');
      $filter_dropdown.addClass('active');
    } else {
      if($filters.filter(':checked').length){
        $filter_dropdown.addClass('active');
        $products_innerwrap.addClass('filtered');
        $filters.filter(':checked').each(function(){
          selector += '[data-product-tags*="\\"' + $(this).val() + '\\""]';
        });

        $(selector).each(function(){
          possible_tags = possible_tags.concat($(this).data('product-tags'));
        });

        $filters.filter(':not(:checked)').each(function(){
          if(!possible_tags.includes($(this).val())) {
            $(this).prop('disabled', true);
            var new_tooltip = new Foundation.Tooltip($(this).next('.filter__label'), {tipText: "No products also match this filter, remove a filter first", clickOpen: false});
            $(this).addClass('tooltip');
          }
        });
      } else {
        if(!on_load){
          $filter_dropdown.removeClass('active');
          $products_innerwrap.removeClass('filtered');
        }
      }
    }
    if(selector != ''){
      selector += ':not([data-product-tags*="duplicate"])';
    }
    return selector;
  }
  disableFilters(false, true);

  //update products on back/forward
  window.addEventListener('popstate', function(e) {
    if(window.location.pathname.includes('/pages/shop')){
      $single_filter = false;
      if (e.state == null) {
        //reset to on load content
        $not_default_filters.prop('checked', false);
        $default_filters.prop('checked', true);
      } else {
        $filters.prop('checked', false);
        if(e.state.name == 'product-filter'){
          e.state.tags.forEach(function(tag) {
            $('.filter-child[value="' + tag + '"]').prop('checked', true);
          });
          var $single_button = $('button[name="product-filter"][value="' + e.state.tags[0] + '"]');
          if($single_button.length){
            $single_filter = $single_button;
          }
        }
      }
      filterProducts($single_filter);
    }
  });

  $open_filters.click(function(){
    openFilters();
  });

  $close_filters.click(function(){
    closeFilters();
  });

  $clear_filters.click(function(){
    $filters.prop( "checked", false );
    filterUpdateUrl();
    filterProducts();
    closeFilters(100);
  });

  function openFilters(){
    console.log('ddf')
    $open_filters.parent().css('margin-bottom', $filter_dropdown.outerHeight( true ));
    $filter_dropdown.addClass('open');
   // $filter_dropdown.css('paddingTop', $header.outerHeight());
    //$filter_dropdown.css('paddingBottom', $checkout_popup.outerHeight());
    $('body').addClass('js-filter-open');
    //$header.removeClass('nav-up');
  }

  function closeFilters(timeout){
    timeout = timeout || 0;
    $open_filters.parent().css('margin-bottom', 0);
    setTimeout(function(){
      $filter_dropdown.removeClass('open');
    }, timeout);
    $('.dropdown-pane').foundation('close');
    $('body').removeClass('js-filter-open');
  }

  if(Foundation.MediaQuery.atLeast('medium')){
    updateFilterPlugin(true);
  }

  $('.back-to-top').click(function(){
     $("html, body").animate({ scrollTop: 0 }, 500);
      return false;
  });
  });
$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
  if(oldSize == 'small'){
    updateFilterPlugin(true);
  } else if(newSize == 'small'){
    updateFilterPlugin(false);
  }
});
function updateFilterPlugin(is_dropdown){
  var $dropdown = $('.filter-dropdown');
  if(!$dropdown.length){ return; }
  if(is_dropdown){
    $('.filter-dropdown').foundation('_destroy');
    $('.filter-dropdown').removeAttr( 'style' );
    $('.filter-dropdown').each(function(){
      var elem = new Foundation.Dropdown($(this), {hover: true, hoverPane: true});
    });
  } else {
    $('.filter-dropdown').foundation('_destroy');
    $('.filter-dropdown').removeAttr( 'style' );
    $('.filter-dropdown').each(function(){
      var elem = new Foundation.Dropdown($(this), {hover: false, hoverPane: false});
    });
  }
}